// search starts at the back, looks for the word before the current character
export const getLastSegment = (str, smb = '/') => str.substring(str.lastIndexOf(smb));
